import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function LatestNews() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-900">
            最新大瓜
          </h2>
          <p className="text-foreground-500 text-sm mt-1">实时追踪，不错过任何一个瓜</p>
        </div>
        <Link to="/category/jieri-dagua" className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer">
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {latestArticles.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}